<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ln3xYR/tc-custom/9781780102344.jpg?1697132806691" alt="This image is the cover for the book Isabel's Wedding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Isabel's Wedding
      </h1>
      <p class="bookDescription body article font2">
        <b>Family secrets and lies threaten one woman’s upcoming nuptials in this suspenseful turn-of-the-century novel from the author of <i>The Boat House</i>.</b><br/>  <br/> Canterbury, 1900. Olivia Fratton will scream if she hears the words “Isabel’s wedding” one more time; she’s struggling to cope with her little sister’s demands on their limited budget. But Olivia is not the only Fratton with worries: Isabel; older brother Theo; and the “golden boy” of the family, Luke, all have their own troubles. But these pale into insignificance when a letter is delivered from someone none of the family ever expected to hear from again . . .<br/>  <br/><b>Praise for Pamela Oldfield’s novels</b><br/> “Fans of traditional mysteries will welcome British author Oldfield’s elegant historical . . . memorable characters and a juicy family drama will satisfy most readers.” —<i>Publishers Weekly</i> on <i>The Boat House</i><br/>  <br/> “Closely-knit plot . . . all too human characters.” —<i>Booklist</i> on <i>The Great Betrayal</i><br/>  <br/> “More atmospheric than mysterious, with a mournful tinge but a happy finale—a mild, pleasant Gothic romance of the old school.” —<i>Kirkus Reviews</i> on <i>The Boat House</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pamela Oldfield
      </h2>
      
      <p class="authorDescription body article">Pamela Oldfield's books have been translated into Spanish, German and Russian. Her adult novels are described as a blend of historical fiction and family saga, each one thoroughly researched with the help of her husband, Joseph, who photographs and videos the various locations necessary for the backgrounds.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01b3b9cb